import React from 'react'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import TargetInput, {
  TargetInputProps,
} from 'Event/Dashboard/components/NavButton/NavButtonConfig/TargetInput'
import ContentInput from 'Event/Dashboard/components/NavButton/NavButtonConfig/ContentInput'
import VisibilityField from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Settings/VisibilityField'
import ActionField from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Settings/ActionField'
import TagFields from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Settings/TagFields'
import WebhookFields from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Settings/WebhookFields'

export default function Settings(
  props: {
    button: NavButtonWithSize
  } & Omit<TargetInputProps, 'button'>,
) {
  const {control, button, watch, register, setValue} = props

  return (
    <>
      <VisibilityField button={button} control={control} />
      <ContentInput
        button={button}
        control={control}
        register={register}
        watch={watch}
        disableImageInput
      />
      <ActionField button={button} control={control} />
      <TargetInput
        button={button}
        control={control}
        register={register}
        watch={watch}
        setValue={setValue}
      />
      <TagFields button={button} control={control} />
      <WebhookFields
        button={button}
        control={control}
        register={register}
        watch={watch}
      />
    </>
  )
}
